module.exports = __webpack_public_path__ + "static/media/ss.de6a1495.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ss.svg
// module id = 253
// module chunks = 0